/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCaseChange = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m4.293 18.438.958-2.806h5.064l.958 2.806h2.378L8.861 6H6.756L2 18.438zm5.406-4.62H5.867L7.766 8.19zm7.716 4.825a3.47 3.47 0 0 0 1.66-.402 3.454 3.454 0 0 0 1.248-1.137l.291 1.334H22V12.33c0-2.053-1.17-3.08-3.507-3.08a8.88 8.88 0 0 0-1.711.172c-.582.114-1.1.268-1.557.462v1.625c1.152-.422 2.178-.633 3.08-.633.604 0 1.026.103 1.266.308.24.205.359.593.359 1.163v.428h-1.694c-1.186 0-2.121.268-2.806.804-.684.536-1.026 1.272-1.026 2.207 0 .878.27 1.574.812 2.087s1.275.77 2.199.77zm.428-1.574c-.457 0-.81-.128-1.061-.385-.251-.256-.377-.613-.377-1.069 0-1.004.69-1.506 2.07-1.506h1.49v1.694c-.24.4-.548.71-.925.933s-.775.333-1.197.333z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCaseChange as CaseChange };
